import { CellContext } from '@tanstack/react-table';
import styled from 'styled-components';
import { TestQuestionRow } from './StepQuestionsResultsTable';

const TypeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const TypePill = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.bgDefaultSecondary};
  border: 1px solid ${({ theme }) => theme.colors.divider};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

// Mapping from machine format to user-friendly labels
export const typeLabels: Record<string, string> = {
  'text-input': 'Text Input',
  'multiple-choice': 'Multiple Choice',
  'multiple-rating': 'Multiple Rating',
  ranking: 'Ranking',
  matching: 'Matching',
  'fill-in-the-gap': 'Fill in the Gap',
  'matrix-ranking': 'Matrix Ranking',
  'text-template': 'Text Template',
  'py-playground': 'Python Playground',
  'llm-playground': 'LLM Playground',
  'py-editor': 'Python Editor',
  'llm-editor': 'LLM Editor',
};

export default function QuestionTypeCell(
  props: CellContext<TestQuestionRow, unknown>
) {
  const type = props.row.original.section.type;
  const hasFollowUp = !!props.row.original.section?.followUpContent;

  const typeLabel = typeLabels[type] || type;

  return (
    <TypeContainer>
      <TypePill>{typeLabel}</TypePill>
      {hasFollowUp && <TypePill>Follow-up</TypePill>}
    </TypeContainer>
  );
}
